// Armar la lista de ocasiones a partir de una sola pregunta.
//
// POR QUÉ UNA PREGUNTA Y NO UNA LISTA PARA TILDAR
//
// La pregunta obvia sería "¿qué ocasiones necesitás?" con doce
// casillas. Es exactamente la pregunta que esto viene a evitar: alguien
// que recién entra no sabe qué ocasiones necesita —no vio todavía cómo
// las usa la app— y tildar doce casillas a ciegas produce una lista
// peor que cualquier default.
//
// "¿Cómo es tu día?" se contesta sin pensar y sin saber nada de la app.
// De ahí sale una lista razonable, y corregirla después es fácil porque
// para entonces ya se entiende para qué sirve.
//
// LO QUE NO SE PIERDE
//
// Un usuario que ya tenía prendas cargadas conserva las ocasiones base
// que esas prendas usan: el servidor las copia antes de sembrar. Se
// dice en pantalla, porque "elegí un paquete" al lado de 167 prendas ya
// clasificadas suena a que algo se va a romper.

import { useState } from "react";
import * as api from "./api";
import { invalidarOpciones } from "./opciones";
import { t, tError, useIdioma } from "./i18n";

export default function ArmarListas({ paquetes, onListo }) {
  useIdioma();
  const [elegido, setElegido] = useState(null);
  const [yendo, setYendo] = useState(false);
  const [error, setError] = useState("");

  async function sembrar() {
    if (!elegido) return;
    setYendo(true);
    setError("");
    try {
      const r = await api.sembrarOcasiones(elegido);
      // La lista de ocasiones cambió entera: sin tirar el caché, los
      // filtros de todas las pantallas seguirían mostrando la vieja.
      invalidarOpciones();
      onListo?.(r);
    } catch (e) {
      setError(tError(e));
    } finally {
      setYendo(false);
    }
  }

  return (
    <div className="armar-listas">
      <p className="texto-mini tenue" style={{ marginTop: 0 }}>
        {t(
          "listas.queSonOcasiones",
          "Las ocasiones son lo que hace que la app sepa qué prendas pueden ir juntas. Elige la que más se parezca a tu día y armo una lista para empezar; después la cambias."
        )}
      </p>

      {error && <div className="mensaje-error texto-mini" role="alert">{error}</div>}

      <div className="niveles">
        {(paquetes || []).map((p) => (
          <button
            key={p.clave}
            type="button"
            className={`nivel-op ${elegido === p.clave ? "nivel-activo" : ""}`}
            onClick={() => setElegido(p.clave)}
          >
            <strong>{t(`opciones.paquete.${p.clave}`, p.etiqueta)}</strong>
            <span className="tenue texto-mini">{t(`opciones.paqueteDetalle.${p.clave}`, p.detalle)}</span>
          </button>
        ))}
      </div>

      {/* Se dice ANTES de tocar el botón, no después. Alguien con
          prendas ya cargadas necesita saber que no va a perder nada
          justo cuando está por decidir. */}
      <p className="texto-mini tenue">
        {t(
          "listas.sembrarConserva",
          "Si ya cargaste prendas, las ocasiones que esas prendas usan se conservan. No se pierde nada."
        )}
      </p>

      <button
        className="boton-secundario"
        onClick={sembrar}
        disabled={!elegido || yendo}
      >
        {yendo ? "Armando..." : "Armar mi lista"}
      </button>
    </div>
  );
}
